import type { CSSProperties } from "react";
import { CV } from "@/config/canvasSizing";
import { THEME } from "@/config/theme";

// Shared selection styling for NodeResizer (nodes + shapes). The gapped
// selection outline is the NODE'S OWN dashed border (see NodeCard) — so here we
// HIDE React Flow's separate resize-box line (it would be a second, competing
// outline) and keep only small round indigo dots at the corners for grabbing a
// resize.
export const NODE_HANDLE_STYLE: CSSProperties = {
  width: CV.handle.resizeW,
  height: CV.handle.resizeH,
  borderRadius: "9999px",
  background: THEME.raw.edgeStrokeSelected,          // indigo-400
  border: `1.5px solid ${THEME.raw.edgeDotColor}`,   // indigo-300 ring
};

export const NODE_LINE_STYLE: CSSProperties = { borderColor: "transparent" };
